import InvoiceRemark from './InvoiceRemark';
import type SupplementType from './SupplementType';

class TooMuchNonAmountSupplementRemark extends InvoiceRemark {
    NomenclatureNumber: string;
    SupplementType: SupplementType;

    info(t: Function): React.ReactElement {
        return <p>{this.NomenclatureNumber} {t('HasSupplementType')} {this.SupplementType}.</p>;
    }

    constructor(nomenclatureNumber: string, supplementType: SupplementType) {
        super();
        this.NomenclatureNumber = nomenclatureNumber;
        this.SupplementType = supplementType;
    }
}

export default TooMuchNonAmountSupplementRemark;
